import ForeHead from 'assets/images/symptom-checker/forehead.png';
import Mouth from 'assets/images/symptom-checker/mouth.png';
import Nose from 'assets/images/symptom-checker/nose.png';
import Eyes from 'assets/images/symptom-checker/eyes.png';
import Ear from 'assets/images/symptom-checker/ear.png';
import Neck from 'assets/images/symptom-checker/neck.png';
import Back from 'assets/images/symptom-checker/back.png';
import Shoulder from 'assets/images/symptom-checker/shoulder.png';
import UpperBack from 'assets/images/symptom-checker/upper_back.png';
import UpperArm from 'assets/images/symptom-checker/upper_arm.png';
import LowerBack from 'assets/images/symptom-checker/lower_back.png';
import Forearm from 'assets/images/symptom-checker/forearm.png';
import Chest from 'assets/images/symptom-checker/chest.png';
import Hands from 'assets/images/symptom-checker/hands.png';
import Waist from 'assets/images/symptom-checker/waist.png';
import Hips from 'assets/images/symptom-checker/hips.png';
import Calves from 'assets/images/symptom-checker/calves.png';
import Thighs from 'assets/images/symptom-checker/thighs.png';
import Feet from 'assets/images/symptom-checker/feet.png';
import Heels from 'assets/images/symptom-checker/heels.png';
import Body from 'assets/images/symptom-checker/body.png';

export enum SYMPTOM_CODE {
  SELECT_BODY_PART = 'body_symptoms',
  FEEL_SYMPTOMS = 'physical_symptoms',
  PAIN_LEVEL = 'pain_level',
  SYMPTOMS_DURATION = 'experiencing_condition',
  STARTED_MEDICATION = 'medication_remedies',
  IMAGE_UPLOAD = 'image_upload',
  ADDITIONAL_DETAIL = 'additional_symptoms_details',
  OTHER_BODY_PART = 'other_body_symptoms',
  OTHER_SYMPTOMS = 'symptoms_other_parts',

  CONFIRMATION = 'pop_up',
}

export function getBodyImage(part: string) {
  if (part === 'Forehead') {
    return ForeHead;
  }
  if (part === 'Mouth') {
    return Mouth;
  }
  if (part === 'Nose') {
    return Nose;
  }
  if (part === 'Eyes') {
    return Eyes;
  }
  if (part === 'Ear') {
    return Ear;
  }
  if (part === 'Neck') {
    return Neck;
  }
  if (part === 'Back') {
    return Back;
  }
  if (part === 'Shoulder') {
    return Shoulder;
  }
  if (part === 'Upper back') {
    return UpperBack;
  }
  if (part === 'Upper Arm') {
    return UpperArm;
  }
  if (part === 'Lower Back') {
    return LowerBack;
  }
  if (part === 'Forearm') {
    return Forearm;
  }
  if (part === 'Chest') {
    return Chest;
  }
  if (part === 'Hands') {
    return Hands;
  }
  if (part === 'Waist/Torso') {
    return Waist;
  }
  if (part === 'Hips') {
    return Hips;
  }
  if (part === 'Calves') {
    return Calves;
  }
  if (part === 'Thighs') {
    return Thighs;
  }
  if (part === 'Feet') {
    return Feet;
  }
  if (part === 'Heels') {
    return Heels;
  }
  return Body;
}
